import React, { Component } from 'react';

import NavBar from '../../components/navigation/NavBar';
import RateView from '../../components/rateview/RateView';
import ModalDialog from '../../components/modal/ModalDialog';

import { getCurrentResource } from '../../util/tools';
import { canPerformAction } from '../../util/localStorage';
import { FORM_EBOOK_SUPPLIER_TABLE } from '../../util/consts/forms';
import { ACTION_EBOOK_SUPPLIER_UPLOAD } from '../../util/consts/actions';
import { 
	performApiRequest, performApiDownloadRequest, performApiRequestForm, 
	ACTION_EBOOK_SUPPLIER_UPLOAD_API_URL, ACTION_EBOOK_SUPPLIER_EXPORT_API_URL,
	ACTION_EBOOK_SUPPLIER_UPLOAD_WL_LOCAL_FILE_API_URL, 
	ACTION_EBOOK_SUPPLIER_UPLOAD_WL_SERVER_FILE_API_URL,
} from '../../util/restapi';

import iconExport from '../../assets/icons/png24x24/send_message.png';
import iconUploadWhiteList from '../../assets/icons/png24x24/send_wl.png';
import iconSave from '../../assets/icons/png24x24/Save.png';

const UPLOAD_MODE_LOCAL = 'local';
const UPLOAD_MODE_SERVER = 'server';

const formatList = [
	{ value: "json", label: "JSON" },
	{ value: "xml", label: "XML" },
	{ value: "json-bank-formatted", label: "JSON для банків (форматований)" },
	{ value: "json-bank-notformatted", label: "JSON для банків (неформатований)" },
];

class EBookSupplierListPage extends Component {
	
	constructor(props) {
		super(props);
		this.refExportModalDialog = React.createRef();
		this.refUploadWhiteListModalDialog = React.createRef();
		this.refUploadWhiteListFromFileModalDialog = React.createRef();

		this.resource = getCurrentResource().pages.tableform.EBookSupplierList;
		let paramCacheId = props.match.params.param;

		this.rvContext = {
			form: FORM_EBOOK_SUPPLIER_TABLE,
			data: []
		};
		this.rvOptions = {
			form: FORM_EBOOK_SUPPLIER_TABLE,
			formTitle: this.resource.formTitle,
			controlPanelTools: this.controlPanelTools(),
			paramCacheId: paramCacheId,
			transition: null,
			hideButtonSendEmail: true,
		};
	}
	componentDidMount() {
		document.title = 'BOM. ' + this.resource.formTitle;
	}

	openExportModalDialog = () => {
		this.refExportModalDialog.current.openModal();
	}
	openUploadWhiteListModalDialog = async () => {
		this.refUploadWhiteListModalDialog.current.openModal();
	}
	openUploadWhiteListFromFileModalDialog = async () => {
		this.refUploadWhiteListFromFileModalDialog.current.openModal();
	}
	
	controlPanelTools = () => {
		return (
			<div style={{textAlign: 'left', marginLeft: '20px'}}>
				<ControlPanelButtonExport holder={this} />
				<ControlPanelButtonUploadWhiteList holder={this} />
				<ControlPanelButtonUploadWhiteListFromFile holder={this} />
			</div>			
		);
	}

	render() {
		return (
			<React.Fragment>
				<NavBar app={this.props.app} />
				<RateView rvContext={this.rvContext} rvOptions={this.rvOptions} app={this.props.app}  />

				<ExportModalDialog ref={this.refExportModalDialog} page={this} />
				<UploadWhiteListModalDialog ref={this.refUploadWhiteListModalDialog} page={this} />
				<UploadWhiteListFromFileModalDialog ref={this.refUploadWhiteListFromFileModalDialog} />
			</React.Fragment>
		)
	}
	
}

function ControlPanelButtonExport(props) {
	return (
		<button type='button' style={{marginLeft: '5px', width: '36px', height: '30px'}}
			 onClick={props.holder.openExportModalDialog}
			 title={props.holder.resource.buttonExportTooltip} 
		>
			<img src={iconExport} />
		</button>			
	);
}
function ControlPanelButtonUploadWhiteList(props) {
	
	if( canPerformAction( ACTION_EBOOK_SUPPLIER_UPLOAD ) ) {
		return (
			<button type='button' style={{marginLeft: '5px', width: '36px', height: '30px'}}
				 title={props.holder.resource.buttonUploadWhiteList} 
				 onClick={props.holder.openUploadWhiteListModalDialog}
			>
				<img src={iconUploadWhiteList} />
			</button>			
		);
	} else {
		return null;
	}
}
function ControlPanelButtonUploadWhiteListFromFile(props) {
	if( canPerformAction( ACTION_EBOOK_SUPPLIER_UPLOAD ) ) {
		return (
			<button type='button' style={{marginLeft: '5px', width: '36px', height: '30px'}}
				 onClick={props.holder.openUploadWhiteListFromFileModalDialog}
				 title={'Відправити білий список з існуючого файлу'} 
			>
				<img src={iconSave} />
			</button>			
		);
	} else {
		return null;
	}
}

//--------------------------------------------------------------------------------------------------
//   ExportModalDialog
//--------------------------------------------------------------------------------------------------

class ExportModalDialog extends ModalDialog {

	constructor(props) {
		super(props);
		let resource = props.page.resource;
		this.title=resource.modalExportTitle;

		this.state.fileName = '';
		this.state.format = "json";
	}
	getStyleModal() {
		let style = super.getStyleModal();
		style.modal.maxWidth = '600px';
		return style;
	}

	handleInputEdit = (e) => {
		const { name, value } = e.target;
		if( name == 'filename' )
			this.setState({fileName: value});
	};
	handleFormatSelectClick = (e) => {
		this.setState({format: e.target.value});
	}

	async performRequest() {
		let listInstanceId = [];
		for( let row of this.props.page.rvContext.data ) {
			if( row.checked ) {
				listInstanceId.push( row.id );
			}
		}
		let exportOptions = {
			debugMode: false,
			format: this.state.format,
			listInstanceId: listInstanceId,
		};
		let response = await performApiDownloadRequest(
			ACTION_EBOOK_SUPPLIER_EXPORT_API_URL, exportOptions, 'text/' + this.state.format);
		if( response.success ) {
			let fileName = this.state.fileName;
			if( ! fileName )
				fileName = 'export_ebook_supplier.' + this.state.format;
			const blobUrl = window.URL.createObjectURL(response.blob);
			const link = document.createElement('a');
			link.href = blobUrl;
			link.download = fileName;
			document.body.appendChild(link);
			link.click();
		}
		return response;
	}

	renderForm() {
		let resource = this.props.page.resource;
		let optionsHtml = formatList.map( (format, index) => {
			return (<option key={index} value={format.value}>{format.label}</option>);
		} );
		return (
			<div style={{marginTop: '10px', padding: '10px'}}>
				<div>
					{resource.labelFile} 
					<input type="text" name="filename" style={{marginLeft: '10px', width: '400px'}}
						value={this.state.fileName} onChange={ this.handleInputEdit}
					/>
				</div>
				<div style={{ display: "flex", alignItems: 'center', marginTop: '20px' }}>
					<div>{resource.labelFormat}</div>
					<div style={{ marginLeft: "10px"}}>
						<select value={this.state.format} onChange={this.handleFormatSelectClick}>
							{optionsHtml}
						</select>
					</div>
 				</div>
			</div>
		)
	}
}

//--------------------------------------------------------------------------------------------------
//   UploadWhiteListModalDialog
//--------------------------------------------------------------------------------------------------

class UploadWhiteListModalDialog extends ModalDialog {
	constructor(props) {
		super(props);

		this.title='Відправити білий список';
	}
	getStyleModal() {
		let style = super.getStyleModal();
		style.modal.maxWidth = '600px';
		return style;
	}
	
	async performRequest() {
		let listInstanceId = [];
		for( let row of this.props.page.rvContext.data ) {
			if( row.checked ) {
				listInstanceId.push( row.id );
			}
		}
		let request = {
			listInstanceId: listInstanceId,
			debugMode: false
		}
		return await performApiRequest(ACTION_EBOOK_SUPPLIER_UPLOAD_API_URL, request);
	}

	renderForm() {
		return (
			<div style={{margin: '15px'}}>
				<div style={{textAlign: 'center', fontSize: '16pt', marginBottom: '20px'}}>
					Передати білий список
				</div>
				<div style={{textAlign: 'center', fontSize: '14pt', marginBottom: '20px'}}>
					Поточний список замінить попередній
				</div>
			</div>
		)
	}
}

//--------------------------------------------------------------------------------------------------
//   UploadWhiteListFromFileModalDialog
//--------------------------------------------------------------------------------------------------

class UploadWhiteListFromFileModalDialog extends ModalDialog {

	selectedFile = null;

	constructor(props) {
		super(props);

		// this.showTryAgainButton = false;
		this.title='Відправити білий список';

		this.fileRef = React.createRef();
		this.state.uploadMode = UPLOAD_MODE_LOCAL;
		this.state.filePath = '';
		this.state.fileName = '';
	}
	
	getStyleModal() {
		let style = super.getStyleModal();
		style.modal.maxWidth = '600px';
		return style;
	}

	onUploadModeChange = (e) => {
		this.setState({uploadMode: e.target.value});
	}
	onFilePathChange = (event) =>	{
		this.setState({ filePath: event.target.value });
	}
	onFileSelect = (e) => {
		let files = e.target.files;
		if( files && files.length > 0 ) {
			this.selectedFile = files[0];
			this.setState({fileName: this.selectedFile.name})
		}
	}	

	async performRequest() {
		if( this.state.uploadMode == UPLOAD_MODE_SERVER ) {
			let request = {
				//fileName: '/media/data/Stock/AppDownloads/BomWhiteList/2026-04-20_02-46-53-966_manual.json',
				fileName: this.state.filePath 
			}
			let response = await performApiRequest(ACTION_EBOOK_SUPPLIER_UPLOAD_WL_SERVER_FILE_API_URL, request);
			return response;
		} else if( this.state.uploadMode == UPLOAD_MODE_LOCAL ) {
			const form = new FormData();
			form.append('data', this.selectedFile);
			let response = await performApiRequestForm(ACTION_EBOOK_SUPPLIER_UPLOAD_WL_LOCAL_FILE_API_URL, form);
			return response;
		} else {
			return {success: false, message: 'Unknown uploadMode: ' + this.state.uploadMode};
		}			
	}
	
	renderForm() {
		let divFile = null;
		if( this.state.uploadMode == UPLOAD_MODE_SERVER ) {
			divFile = (
				<div style={{marginTop: '15px'}}>
					{'Файл'}: <input type='text' size='40' value={this.state.filePath} onChange={this.onFilePathChange} /> 
				</div>
			);
		} else if( this.state.uploadMode == UPLOAD_MODE_LOCAL ) {
			divFile = (
				<div style={{marginTop: '15px'}}>
					{'Файл'}: <span>{this.state.fileName}</span> 
					&nbsp;<button disabled={false} onClick={e => this.fileRef.current.click()}>{'Вибрати'}</button>
				</div>
			);
		}
		return (
			<div style={{padding: '20px'}}>
				<div>
					<select value={this.state.uploadMode} onChange={this.onUploadModeChange}>
						<option value={UPLOAD_MODE_LOCAL}>{'Локальний файл'}</option>
						<option value={UPLOAD_MODE_SERVER}>{'Файл на сервері'}</option>
					</select>
				</div>
				{divFile}
				<input ref={this.fileRef} type={'file'} style={{display: 'none'}} onChange={e => this.onFileSelect(e)} />
			</div>
		)
	}
	
}

export default EBookSupplierListPage;
